import Hero from "../components/Hero";
import Stats from "../components/Stats";
import Welcome from "../components/Welcome";
import SalientFeatures from "../components/SalientFeatures";
import CampusGallery from "../components/CampusGallery";
import WhyChoose from "../components/WhyChoose";
import AdmissionBanner from "../components/AdmissionBanner";
import SchoolGallery from "../components/SchoolGallery";
import Activities from "../components/Activities";

import "../styles/main.css";

function Home({ mode }) {
  return (
    <>
      {/*  HERO */}
      <Hero mode={mode} />

      {/*  STATS */}
      <Stats mode={mode} />

      {/*  WELCOME */}
      <Welcome mode={mode} />

      {/*  SALIENT FEATURES Only College */}
      {mode === "college" && <SalientFeatures />}

      {/*  MAIN CONTENT */}
      {mode === "college" ? (
        <>
          <CampusGallery />
          <WhyChoose mode={mode} />
        </>
      ) : (
        <>
          <Activities />
          <SchoolGallery />
        </>
      )}

      {/*ADMISSION */}
      <AdmissionBanner mode={mode} />

     
    </>
  );
}

export default Home;